import React from 'react';
import { useSelector } from 'react-redux';
import camelCaseKeys from 'camelcase-keys';

import ExpressCheckout from 'src/shoppe/compositions/ExpressCheckout';
import { ICartV2 } from 'src/explore/types/shoppe';

import styles from './index.module.sass';

const ExpressCheckoutScene = () => {
  // The type of state is IStore but we need to use any here
  // camelCaseKeys is written to return the same type as the input

  const cart = useSelector<any, ICartV2>(( state ) =>
    camelCaseKeys( state.data.cart?.data, { deep: true })
  );

  if ( !cart ) return null;

  return (
    <div className={styles.container}>
      <ExpressCheckout cart={cart} />
    </div>
  );
};

export default ExpressCheckoutScene;
